import React from 'react';
import { connect } from 'react-redux';
import { Row, Modal, ModalHeader, ModalFooter, ModalBody, Button } from 'reactstrap';
import CategoryTile from '../components/CategoryTile';
import Card from './Card';

import download_googleplay from '../images/download_googleplay.png';
import download_appstore from '../images/download_appstore.png';

class Categories extends React.Component {
  constructor() {
    super();

    this.state = {
      showModal: false,
      category: {},
      maxCount: 4
    }

    this.view = this.view.bind(this);
    this.toggle = this.toggle.bind(this);
    this.isMobileDevice = this.isMobileDevice.bind(this);
  }

  componentDidMount() {
    const isMobileDevice = this.isMobileDevice();
    this.setState({isMobileDevice});
  }

  // eslint-disable-next-line class-methods-use-this
  isMobileDevice() {
    const { userAgent } = navigator;
    return /Android|iPhone|iPad|mobile|Windows Phone/i.test(userAgent);
  }

  view(category) {
    this.setState({category, showModal: true})
  };

  renderCategories() {
    const { categories, maxCount, isMobileDevice  } = this.props.selftest;
    return categories.map((category, index) => (<CategoryTile key={index} category={category} onClick={this.view}/>));
  };

  toggle() {
    this.setState({showModal: !this.state.showModal})
  }

  render() {
    const { category, showModal, maxCount, isMobileDevice } = this.state;

    let mobileExtra = '';
    if (isMobileDevice) mobileExtra = `to get the all the ${category?.cards?.length} cards for this category. This demo is limited to ${maxCount} cards.`;

    return (
      <div>
        <Modal
          isOpen={showModal}
          toggle={this.toggle}
          centered
        >
          <ModalHeader toggle={this.toggle} className="text-white bg-corporate">{category.name}</ModalHeader>
          <ModalBody>
            <Card id={category.id} />
          </ModalBody>
        </Modal>

        <Row className="mt-2">
          {this.renderCategories()}
        </Row>

        <div className="d-flex justify-content-center mt-2">
          <div>
            <div className="p-3" style={{fontSize: 16}}>Download the app from <a href="https://apps.apple.com/au/app/marine-master-self-test/id1082550084" target="_blank" rel="noreferrer">App Store</a> or Google Play {mobileExtra}</div>
            <div className="d-flex justify-content-center mt-2">
              <img style={{width: 200}} src={download_googleplay} alt="Download on Google Play" />
              <a href="https://apps.apple.com/au/app/marine-master-self-test/id1082550084" target="_blank" rel="noreferrer">
                <img style={{width: 200}} src={download_appstore} alt="Download in App Store" />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStoreToProps = (store) => ({
    selftest: store.selftest,
  }
);

export default connect(mapStoreToProps)(Categories);
